export type NotificationPreferenceKey =
  | "dealUpdates"
  | "stageAdvancement"
  | "documentUploads"
  | "messages"
  | "billing";

export interface NotificationPreferences {
  dealUpdates: boolean;
  stageAdvancement: boolean;
  documentUploads: boolean;
  messages: boolean;
  billing: boolean;
}

export const defaultNotificationPreferences: NotificationPreferences = {
  dealUpdates: true,
  stageAdvancement: true,
  documentUploads: true,
  messages: true,
  billing: true,
};

export function normalizeNotificationPreferences(
  value?: unknown,
): NotificationPreferences {
  if (!value || typeof value !== "object" || Array.isArray(value)) {
    return defaultNotificationPreferences;
  }

  const incoming = value as Partial<Record<NotificationPreferenceKey, unknown>>;

  return {
    dealUpdates: incoming.dealUpdates !== false,
    stageAdvancement: incoming.stageAdvancement !== false,
    documentUploads: incoming.documentUploads !== false,
    messages: incoming.messages !== false,
    billing: incoming.billing !== false,
  };
}

export function getNotificationPreferenceKey(
  notificationType?: string | null,
): NotificationPreferenceKey | null {
  switch (notificationType) {
    case "deal":
      return "dealUpdates";
    case "matter":
      return "stageAdvancement";
    case "document":
      return "documentUploads";
    case "message":
    case "buyer_message":
    case "seller_message":
      return "messages";
    case "billing":
    case "payment":
      return "billing";
    default:
      return null;
  }
}

export function isNotificationTypeEnabled(
  notificationType: string | null | undefined,
  preferences: NotificationPreferences,
) {
  const key = getNotificationPreferenceKey(notificationType);
  if (!key) {
    return true;
  }

  return preferences[key];
}
